<template>
  <!-- 关于我们 -->
  <div class="aboutUs" :style="{ opacity: showAbout == 1 ? 1 : 0 }">
    <div class="aboutContent">
      <!-- 文字介绍 -->
      <img
        class="feiyin-about"
        src="../assets/images/logo/feiyin-about.png"
        alt=""
        :style="{
          opacity: liLight == 0 ? 1 : 0,
          transform: liLight == 0 ? 'translateX(123%)' : 'translateX(0)'
        }"
      />
      <!-- 我们的客户 -->
      <div
        class="fieyin-client"
        :style="{
          opacity: liLight == 1 ? 1 : 0,
          pointerEvents: liLight == 1 ? 'all' : 'none',
          transform: liLight == 1 ? 'translateX(25%)' : 'translateX(50%)'
        }"
      >
        <div class="clientClick">
          <span @click="toInner(1)"></span>
          <span @click="toInner(4)"></span>
          <span @click="toInner(2)"></span>
          <span @click="toInner(5)"></span>
          <span @click="toInner(4)"></span>
          <span @click="toInner(6)"></span>
          <span @click="toInner(4)"></span>
          <span @click="toInner(4)"></span>
          <span @click="toInner(6)"></span>
          <span @click="toInner(7)"></span>
          <span @click="toInner(2)"></span>
          <span @click="toInner(6)"></span>
          <span @click="toInner(3)"></span>
          <span @click="toInner(1)"></span>
          <span @click="toInner(1)"></span>
        </div>
        <img src="../assets/images/logo/feiyin-client.png" alt="" />
      </div>
    </div>

    <!-- 导航菜单 -->
    <ul>
      <li
        :style="{ opacity: liLight == 0 && showAbout == 1 ? 1 : '' }"
        @click="feiyinIntro"
      >
        <i
          :style="{ background: liLight == 0 && showAbout == 1 ? '#fff' : '' }"
        ></i
        >费隐简介
      </li>

      <li :style="{ opacity: liLight == 1 ? 1 : '' }" @click="feiyinClient">
        <i :style="{ background: liLight == 1 ? '#fff' : '' }"></i>我们的客户
      </li>
      <li @click="feiyinBack"><i></i>返回首页</li>
    </ul>
  </div>
</template>

<script>
import { Bus } from "../bus";
export default {
  data() {
    return {
      liLight: 0,
      showAbout: 0
    };
  },
  methods: {
    // 费隐介绍
    feiyinIntro() {
      this.liLight = 0;
    },
    // 客户
    feiyinClient() {
      this.liLight = 1;
    },
    // 返回主页
    feiyinBack() {
      this.liLight = 0;
      this.showAbout = "";
      // 判断是否移动建筑图片大小和位置，总线提交liActiveNum
      Bus.$emit("liActiveNum", this.liLight);
    },
    // 到内页
    toInner(pageId) {
      let routeUrl = this.$router.resolve({
        path: "/innerpage",
        query: { pageId }
      });
      window.open(routeUrl.href, "_blank");
      // 显示背景：false，总线提交showAppBg
      Bus.$emit("showAppBg", false);
    }
  },
  created() {
    Bus.$on("liActiveNum", liActiveNum => {
      this.showAbout = liActiveNum;
    });
  }
};
</script>

<style>
.aboutUs {
  position: absolute;
  top: 15rem;
  right: 0px;
  width: 100%;
  height: 27rem;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: end;
  align-items: flex-end;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding-right: 5%;
  z-index: 9;

  -webkit-transition: 1s linear;

  transition: 1s linear;
}
.aboutUs ul {
  list-style: none;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  width: 19vw;
  margin-right: 1%;
  min-width: 240px;
}
.aboutUs ul li {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  cursor: pointer;
  opacity: 0.5;

  -webkit-transition: 0.5s linear;

  transition: 0.5s linear;
}
.liOpacity {
  opacity: 1;
}
.aboutUs ul li i {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
  position: relative;
  margin-right: 5px;
  border: 1px solid #fff;

  -webkit-transition: 0.5s linear;

  transition: 0.5s linear;
}
.iBackground {
  background: #fff;
}
.aboutUs ul li i::before {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 50%;
  border: 1px solid;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  opacity: 0.5;
}

.aboutUs .feiyin-about {
  width: 45%;
  -webkit-transition: 1s linear;
  transition: 1s linear;
}

.aboutUs .fieyin-client {
  width: 44%;
  -webkit-transition: 1s linear;
  transition: 1s linear;

  position: relative;
}
.aboutUs .fieyin-client img {
  width: 100%;
}
.aboutUs .fieyin-client .clientClick {
  width: 99%;
  height: 86%;
  position: absolute;
  display: -webkit-box;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  top: 17%;
}
.aboutUs .fieyin-client .clientClick span {
  width: 17%;
  height: 24%;
  cursor: pointer;
}

.aboutUs .aboutContent {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
</style>
